// Define the product configurations and rules
const productRules = {
    'tip1': {
      allowedLayouts: ['linear', 'L-shape', 'U-shape', 'back-to-back'],
      allowedDoubleDrums: ['biodegradable', 'residual'],
      allowedArrangements: ['individual', 'grouped', 'custom'],
      // Add power options
      powerOptions: {
        electric: {
          options: [
            {
              id: 'independent',
              name: 'Independentă (autonomă)',
              accessOptions: [
                {
                  id: 'with-it-platform',
                  name: 'Transmitere date în platformă online',
                  description: 'Eco-insulă dotată cu panou solar și baterie. Se poate personaliza cu diferite funcționalități.'
                },
                {
                  id: 'without-it-platform',
                  name: 'Control acces simplu(fără transmitere date)',
                  description: 'Eco-insulă dotată cu panou solar și baterie. Acces cu cartelă (permite doar accesul, ca o cheie)'
                }
              ]
            },
            {
              id: 'grid-connected',
              name: 'Legată la sursă de curent',
              accessOptions: [
                {
                  id: 'with-it-platform',
                  name: 'Transmitere date în platformă online',
                  description: 'Eco-insulă conectată la sursă de curent. Se poate personaliza cu diferite funcționalități.'
                },
                {
                  id: 'without-it-platform',
                  name: 'Control acces simplu(fără transmitere date)',
                  description: 'Acces cu cartelă (permite doar accesul, ca o cheie)'
                }
              ]
            }
          ]
        },
        nonElectric: {
          options: [
            {
              id: 'mechanical',
              name: 'Cu deschidere mecanică',
              description: 'Acces pentru toată lumea'
            }
          ]
        }
      }
    },
    'tip2': {
      allowedLayouts: [],
      allowedDoubleDrums: ['biodegradable', 'residual', 'paper', 'glass', 'plastic'],
      allowedArrangements: [],
      // Add power options for tip2
      powerOptions: {
        electric: {
          options: [
            {
              id: 'independent',
              name: 'Independentă (autonomă)',
              accessOptions: [
                {
                  id: 'with-it-platform',
                  name: 'Transmitere date în platformă online',
                  description: 'Monitorizează numărul de aruncări per fracție. Blochează aruncarea când este plină. Permite gestionarea în timp real a platformei de către salubrist'
                },
                {
                  id: 'without-it-platform',
                  name: 'Control acces simplu(fără transmitere date)',
                  description: 'Acces cu cartelă (permite doar accesul, ca o cheie)'
                }
              ]
            },
            {
              id: 'grid-connected',
              name: 'Legată la sursă de curent',
              accessOptions: [
                {
                  id: 'with-it-platform',
                  name: 'Transmitere date în platformă online',
                  description: 'Monitorizează numărul de aruncări per fracție. Blochează aruncarea când este plină. Permite gestionarea în timp real a platformei de către salubrist'
                },
                {
                  id: 'without-it-platform',
                  name: 'Control acces simplu(fără transmitere date)',
                  description: 'Acces cu cartelă (permite doar accesul, ca o cheie)'
                }
              ]
            }
          ]
        },
        nonElectric: {
          options: [
            {
              id: 'mechanical',
              name: 'Cu deschidere mecanică',
              description: 'Acces pentru toată lumea'
            }
          ]
        }
      }
    },
    'tip3': {
      allowedLayouts: [],
      allowedDoubleDrums: ['biodegradable', 'residual', 'paper', 'glass', 'plastic'],
      allowedArrangements: [],
      // Add power options for tip3
      powerOptions: {
        electric: {
          options: [
            {
              id: 'independent',
              name: 'Independentă (autonomă)',
              accessOptions: [
                {
                  id: 'with-it-platform',
                  name: 'Transmitere date în platformă online',
                  description: 'Monitorizează numărul de aruncări per fracție. Blochează aruncarea când este plină. Permite gestionarea în timp real a platformei de către salubrist'
                },
                {
                  id: 'without-it-platform',
                  name: 'Control acces simplu(fără transmitere date)',
                  description: 'Acces cu cartelă (permite doar accesul, ca o cheie)'
                }
              ]
            },
            {
              id: 'grid-connected',
              name: 'Legată la sursă de curent',
              accessOptions: [
                {
                  id: 'with-it-platform',
                  name: 'Transmitere date în platformă online',
                  description: 'Monitorizează numărul de aruncări per fracție. Blochează aruncarea când este plină. Permite gestionarea în timp real a platformei de către salubrist'
                },
                {
                  id: 'without-it-platform',
                  name: 'Control acces simplu(fără transmitere date)',
                  description: 'Acces cu cartelă (permite doar accesul, ca o cheie)'
                }
              ]
            }
          ]
        },
        nonElectric: {
          options: [
            {
              id: 'mechanical',
              name: 'Cu deschidere mecanică',
              description: 'Acces pentru toată lumea'
            }
          ]
        }
      }
    }
    // Add more product types as needed
  };
  
  // Function to check if a layout is available for a specific product
  export function isLayoutAvailable(productType, layoutType) {
    const productConfig = productRules[productType];
    return productConfig && productConfig.allowedLayouts.includes(layoutType);
  }
  
  // Function to check if double drum is available for a specific fraction
  export function isDoubleDrumAvailable(productType, fractionType) {
    const productConfig = productRules[productType];
    return productConfig && productConfig.allowedDoubleDrums.includes(fractionType);
  }
  
  // Function to get all available layouts for a product
  export function getAvailableLayouts(productType) {
    const productConfig = productRules[productType];
    return productConfig ? productConfig.allowedLayouts : [];
  }
  
  // Function to get all fractions that can have double drums for a product
  export function getDoubleDrumFractions(productType) {
    const productConfig = productRules[productType];
    return productConfig ? productConfig.allowedDoubleDrums : [];
  }
  
  // Function to check if a specific arrangement is available for a product
  export function isArrangementAvailable(productType, arrangement) {
    const productConfig = productRules[productType];
    return productConfig && productConfig.allowedArrangements.includes(arrangement);
  }
  
  // Function to get all available arrangements for a product
  export function getAvailableArrangements(productType) {
    const productConfig = productRules[productType];
    return productConfig ? productConfig.allowedArrangements : [];
  }
  
  // New functions for power options
  
  // Function to get all power options for a product
  export function getPowerOptions(productType) {
    const productConfig = productRules[productType];
    return productConfig ? productConfig.powerOptions : null;
  }
  
  // Function to get electric options for a product
  export function getElectricOptions(productType) {
    const productConfig = productRules[productType];
    return productConfig && productConfig.powerOptions ? productConfig.powerOptions.electric.options : [];
  }
  
  // Function to get non-electric options for a product
  export function getNonElectricOptions(productType) {
    const productConfig = productRules[productType];
    return productConfig && productConfig.powerOptions ? productConfig.powerOptions.nonElectric.options : [];
  }
  
  // Function to get access options for a specific electric option
  export function getAccessOptions(productType, electricOptionId) {
    const electricOptions = getElectricOptions(productType);
    const option = electricOptions.find(opt => opt.id === electricOptionId);
    return option ? option.accessOptions : [];
  }